import NetworkLogic from "../../Shared/NetworkLogic";
import htmlBefore  from "../../Shared/htmlBefore";
import htmlAfter  from "../../Shared/htmlAfter";
import htmlBeforeZcs from "../../Shared/htmlBeforeZcs";
import htmlAfterZcs from "../../Shared/htmlAfterZcs";
import AudioManager from "../../Shared/AudioManager";
import UIManager from "../../Shared/UIManager";
import Player from "../../Models/Player";
import HallUI from "../HallUI";
import ActivityData from "./ActivityData";
import {Global} from "../../Shared/Global";
const {ccclass, property} = cc._decorator;

@ccclass
export default class Activity extends cc.Component {

    @property(cc.Prefab)
    kefu: cc.Prefab = null;
    @property(cc.Prefab)
    Drawing: cc.Prefab = null;
    @property(cc.Prefab)
    Recharge: cc.Prefab = null;
    @property(cc.Prefab)
    Extension: cc.Prefab = null;
    @property(cc.Prefab)
    submitPfb: cc.Prefab = null;
    @property(cc.ToggleContainer)
    titContainer: cc.ToggleContainer = null;
    @property(cc.Node)
    titleItem: cc.Node = null;
    @property(cc.Node)
    iconContent: cc.Node = null;
    @property(cc.Node)
    iconItem: cc.Node = null;
    @property(cc.WebView)
    webView: cc.WebView = null;
    @property(cc.Node)
    btnBack: cc.Node = null;
    @property(cc.ScrollView)
    iconScroll: cc.ScrollView = null;
    listItem = {};
    iconContentArr = {};
    tempContent = null;
    submit = null

    private typeParam: string = "";
    @property(cc.Prefab)
    pfbLoginUI: cc.Prefab = null;

    bPlayClick = false;
    private recommendActivity = null;

    onLoad () {
        this.webView.node.active = false;
        this.bPlayClick = false;
    }
    start(){
        // 处理超链接
        let scheme = "http"
        this.webView.setJavascriptInterfaceScheme("http")
        this.webView.setOnJSCallback(function (target, url) {
            cc.log("===url:",url)
            if(url.indexOf("activityId") > -1 || url.indexOf("activityid") > -1){
                let strWeb = url.replace(scheme + '://', '');
                strWeb = strWeb.replace("/","");
                let params  = {
                    "activityId": strWeb.split("&")[0].split("=")[1],
                    "detailId": strWeb.split("&")[1].split("=")[1],
                };
                NetworkLogic.activityApplyRuleActivity(params,function (rec) {
                    UIManager.showToastUI("领取成功", Global.ToastType.OK);
                    this.onBtnBack();
                }.bind(this),function (rec) {
                    UIManager.showToastUI("领取失败", Global.ToastType.Warnning);
                }.bind(this))
            }else{
                cc.sys.openURL(url)
            }
        }.bind(this))
    }


    onDisable(): void {
        this.btnBack.active = false;
        this.webView.node.active = false;
    }

    async updateActivityLayer(recommendActivity?) {
        this.recommendActivity = recommendActivity;
        UIManager.showLoadingUI()
        await this.showTitle();
        UIManager.hideLoadingUI()

    }


    async showTitle() {
        if (this.titContainer.node.children.length > 0) return;//防止切换标题，一直增加按钮
        let typeData = await ActivityData.getRealTypeData()
        for (let i = 0; i < typeData.length; i++) {
            let item = cc.instantiate(this.titleItem);
            item.parent = this.titContainer.node;
            item["id"] = typeData[i].id;
            item.getChildByName("labTitle").getComponent(cc.Label).string = typeData[i].activityTypeName;
            item.getComponent(cc.Toggle).checkEvents[0].customEventData = typeData[i].id;
            item.active = true;
        }
        if (this.recommendActivity) {
            let data = this.recommendActivity
            let toggles = this.titContainer.toggleItems
            for (let i = 0; i < toggles.length; i++) {
                let customData = toggles[i].checkEvents[0].customEventData
                if (customData === data.activityTypeId) {
                    toggles[i].check();
                    toggles[i].checkEvents[0].emit([toggles[i].checkEvents[0].customEventData]);
                    break;
                }
            }
            this.recommendActivity = null;
        } else {
            let tog = this.titContainer.toggleItems[0] as cc.Toggle;
            if (tog) {
                tog.check();
                tog.checkEvents[0].emit([tog.checkEvents[0].customEventData]);
            }
        }
    }

    //分类选择 显示图片内容
    async onLeftSelected(event, param, playSound = true) {
        this.iconScroll.stopAutoScroll();
        if (this.bPlayClick){
            playSound && AudioManager.playSound("toggle");
        }else{
            this.bPlayClick = true;
        }
        this.webView.node.active = false;
        this.btnBack.active = false;
        let listItem = await ActivityData.getListItem();
        let activitys = listItem[param];
        this.typeParam = param;
        if (!activitys) return ;


        this.tempContent  && (this.tempContent.active = false);
        if (!this.iconContentArr[param]){
            let iconContent = cc.instantiate(this.iconContent);
            iconContent.parent = this.iconContent.parent;
            iconContent.active = true;
            this.iconContentArr[param] = iconContent;
            for (let j = 0; j < activitys.length; j++) {//给所有内容赋值
                let iconItem = null;
                iconItem = cc.instantiate(this.iconItem);
                iconItem.parent = iconContent;
                iconItem.getComponent(cc.Button).clickEvents[0].customEventData = JSON.stringify(activitys[j]);
                iconItem["activityId"] = activitys[j].id;
                let lingqu = iconItem.getChildByName("btnLingqu");
                lingqu.active = (activitys[j].applyType === 3 ? false : true);//为3 关闭领取按钮
                lingqu.active = !(activitys[j].atype === 0)
                lingqu.getComponent(cc.Widget).updateAlignment();
                lingqu.getComponent(cc.Button).clickEvents[0].customEventData = JSON.stringify(activitys[j]);
                iconItem.active = true;
            }
            for (let k = 0;k < activitys.length;k++){
                let iconItem = this.iconContentArr[param].children[k];
                this.getImage(activitys[k].activityImgPhone,iconItem);
            }

        }else{
            this.iconContentArr[param].active = true;

        }
        this.tempContent = this.iconContentArr[param];
        this.iconScroll.content = this.iconContentArr[param];
        

    }

    onBtnClick(event,param){
        if (param === "close"){
            cc.log("点击关闭按钮");
            this.btnBack.active = false;
            this.webView.node.active = false;
        }
        AudioManager.playSound("close")
    }

    onBtnBack(event,param){
        this.btnBack.active = false;
        this.webView.node.active = false;
        AudioManager.playSound("button")
    }

    //立即领取几种情况
    onBtnClickLingqu(event,param){
        if(!Player.isLogedIn()){
            this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
            let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            hallUI.checkLoginAndShowUI();
            return;
        }
        cc.log("==点击领取 param：",param);
        let pa = JSON.parse(param);
        if (pa.atype === 0){//规则活动
            let data  =
            {
                "activityId": pa.id,
                "detailId": 0
            }
            if (pa.applyType === 1){//外部跳转
                cc.log("====跳转外部链接");
                cc.sys.openURL(pa.jumpUrl)
            }else if (pa.applyType === 0){//不跳转
                NetworkLogic.activityApplyRuleActivity(data,function (rec) {
                    UIManager.showToastUI('申请规则活动成功，请等待审核!',Global.ToastType.OK)
                    cc.log("====返回规则活动 rec：",rec);
                }.bind(this),function () {
                    //UIManager.showToastUI('申请规则活动失败，请等待审核!')
                    cc.log("====返回规则活动错误");
                }.bind(this))
            }
        }else if (pa.atype === 1){//内容活动
            let data = {};
            if (pa.applyType == 0 || !pa.applyType){//不跳转
                if (
                    pa.submitFlag &&
                    pa.listTip &&
                    pa.listTip instanceof Array &&
                    pa.listTip.length > 0
                ) {//提交资料

                    let submit = cc.instantiate(this.submitPfb);
                    submit.parent = this.node.parent.parent;
                    submit.getComponent("Submit").updataUI(pa);
                }
                else{//不提交资料
                    data = {
                        "id": pa.id,
                    }
                    NetworkLogic.activityApplyContentActivity(data, function (rec) {
                        UIManager.showToastUI('申请成功，请等待审核!',Global.ToastType.OK)
                    }.bind(this), function () {
                        //UIManager.showToastUI('申请失败，请稍后尝试!')
                    }.bind(this))
                }
            }
            else if (pa.applyType === 1){//跳转外部浏览器
                cc.log("=====跳转外部浏览器");
                cc.sys.openURL(pa.jumpUrl)
            }
            else if (pa.applyType === 2) {//内部跳转
                let path = JSON.parse(pa.jumpUrl).path;
                let hallUI :HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                if(path === "Home"){
                    this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
                }else if (path === "Kefu") {
                    hallUI.onBtnClick(null,"customer");
                }else if (path === "Drawing"){// 体现
                    hallUI.onBtnClick(null,"tixian");
                }else if (path === "Recharge"){//充值
                    hallUI.onBtnClick(null,"recharge");
                }else if (path === "Extension"){//推广
                    hallUI.onBtnClick(null,"tuiguang");
                }
            }
        }
        AudioManager.playSound("close")
    }

    getImage(url,iconItem){
        cc.loader.load(url, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(iconItem)){
                    iconItem.getChildByName("logo").active = false;
                    iconItem.getComponent(cc.Sprite) && (iconItem.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture));
                }
            }else {
            }
        }.bind(this))
    }

    //点击图标，显示详情
    onIconClick(event, param, playSound = true) {
        let that = this;
        playSound && AudioManager.playSound("button");
        param = JSON.parse(param)
        let data1 = {
            id: param.id
        }
        if (!Player.isLogedIn() && param.atype === 0){
            this.node.parent.parent.getComponent("ActivityAndTask").onBtnClose();
            let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            hallUI.checkLoginAndShowUI();
            return;
        }
        UIManager.showLoadingUI();
        NetworkLogic.activityGetActivityById(data1, function (data) {
            if(data && data.atype==0){
                UIManager.hideLoadingUI();

                let hdzt = "进行中";
                if(data.status == 0){
                    hdzt = "进行中";
                    // "活动进行中"
                }
                if(data.status == 1){
                    hdzt = "活动未开始";
                }
                if(data.status == 2){
                    hdzt = "活动已结束";
                }
                let str = htmlBeforeZcs + `<h1> ${data.name} </h1><p>活动时间：${data.startTime}~${data.endTime}</p><p>活动状态：${hdzt}</p><div> 活动规则：</div><div>${data.activityContentHtml}</div><table>` + data.tableHtml + '</table>' + htmlAfterZcs;

                this.webView.node.active = true;
                this.btnBack.active = true;
                cc.log("===str:",str);
                if (cc.sys.isBrowser) {
                    // kylin
                    // 延迟一下才对，原因未知
                    cc.Canvas.instance.scheduleOnce(function () {
                        this.webView["_impl"]['_iframe']['contentDocument'].getElementsByTagName('html')[0].innerHTML = str
                    }.bind(this), 0)
                }else{
                    this.webView["_impl"].loadHTMLString(str);
                }
            }else{
                UIManager.hideLoadingUI();
                let str = htmlBefore + data.activityContentHtml + htmlAfter;
                this.webView.node.active = true;
                this.btnBack.active = true;
                this.webView["_impl"].loadHTMLString(str);
                // cc.sys.isNative && this.webView["_impl"]._iframe && this.webView["_impl"]._iframe.setBackgroundTransparent && this.webView["_impl"]._iframe.setBackgroundTransparent(true)
            }
        }.bind(this), function (err) {
            console.log("====传ID 返回错误");
        }.bind(this));
    }
}
